import apiCall from './call'
import stringifyObject from '@/functions/stringifyObject'

const state = {
  models: []
}

const getters = {
  //
}

const actions = {
  getIndex ({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiCall({ url: data.model, qs: data.query })
        .then(response => {
          commit('setIndex', {
            'model': data.model,
            'index': response,
            'query': data.query
          })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getColumns ({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiCall({ url: data.model + '/columns' })
        .then(response => {
          commit('setColumns', {
            'model': data.model,
            'columns': response
          })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  resetIndex ({ commit }, model) {
    commit('unsetIndex', model)
  }
}

const mutations = {
  setIndex (state, data) {
    if (state.models[data.model] === undefined) {
      state.models[data.model] = state.models[data.model] || []
    }

    // stores the entire paged data in the state
    // stored based on the query string
    state.models[data.model]['index'] = state.models[data.model]['index'] || []

    let stateQuery = stringifyObject(data.query)
    state.models[data.model]['index'][stateQuery] = data.index
  },
  unsetIndex (state, model) {
    state.models[model]['index'] = []
  },
  setColumns (state, data) {
    if (state.models[data.model] === undefined) {
      state.models[data.model] = state.models[data.model] || []
    }

    // store the columns per model in the state
    state.models[data.model]['columns'] = data.columns
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/datatableIndex.js